import { Group, Text } from "@mantine/core";
import { DataGridPage, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { Dashboard } from "./Dashboard";

export const ACTVerHistorialUbicacion: EntityClientAction = {
    name: 'ACTVerHistorialUbicacion',
    label: 'Ver Historial Ubicaciones',
    title: <Text fw={700}>Ver Historial Ubicaciones</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalLocalizacionPresentes',
        'dash_brwPersonalLocalizacionAusentes',
        'dash_brwPersonalLocalizacionSinReportar',
        'dash_brwPersonalSinCheckin',
        'dash_brwPersonalSinCheckinSupervisor',
        'dash_brwUbicacionPersonal'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as Dashboard;
        const dashboard = new Dashboard(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys![0].c_personal_id as unknown as string || '';

        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">Historial de Ubicaciones</Text></Group>,
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: <DataGridPage
                key="historial-ubicaciones"
                client={entity.API.client}
                entityConstructor={() => dashboard}
                formMode="view"
                viewName="dash_brwPersonalHistorialUbicaciones"
                refreshOnInit
                title="Historial de Ubicaciones"
                enableAdd={false}
                enableDelete={false}
                enableEdit={false}
                enableView={false}
                showActions={true}
                selectionMode="single" />
        });

        return false;
    }
}